import { useCallback, useEffect } from "react";
import { useRouter } from "next/router";
import { clearRouterPath } from "~/features/app/utils";
const key = "ouster-page-scroll-position";
export function useScrollRestore(allowedPaths: string[]) {
  const router = useRouter();
  const isExactAllowedPage = useCallback((path: string) => allowedPaths.includes(path), [allowedPaths]);
  function restoreScrollPosition() {
    const currentPath = clearRouterPath(router.asPath);
    const hasHash = currentPath.includes("#");
    if (isExactAllowedPage(currentPath)) {
      const savedScrollPosition = window.localStorage.getItem(key);
      if (savedScrollPosition) {
        setTimeout(() => {
          window.scrollTo(0, parseInt(savedScrollPosition, 10));
        }, 100);
        return;
      }
    }
    if (!hasHash) {
      window.scrollTo(0, 0);
    }
  }
  useEffect(() => {
    function handleRouteChangeStart(url: string) {
      if (isExactAllowedPage(clearRouterPath(router.asPath)) && !isExactAllowedPage(url)) {
        const scrollPosition = Math.floor(window.scrollY);
        window.localStorage.setItem(key, String(scrollPosition));
      }
    }
    router.events.on("routeChangeStart", handleRouteChangeStart);
    return () => {
      router.events.off("routeChangeStart", handleRouteChangeStart);
    };
  }, [router.asPath, isExactAllowedPage, router.events]);
  useEffect(() => {
    // clear scroll position from local storage on load
    window.localStorage.removeItem(key);
  }, []);
  return restoreScrollPosition;
}